import permissions from '../permission-list'

export default [
  {
    path: '/vouchers/:id/transactions',
    name: 'voucher-usages-v2',
    component: () => import('@/views/v2/VoucherUsages.vue'),
    meta: {
      pageTitle: 'Penggunaan Voucher',
      resource: permissions.voucherV2,
      action: 'read',
      navActiveLink: 'vouchers-v2',
      breadcrumb: [
        { text: 'Voucher', to: { name: 'vouchers-v2' } },
        { text: 'Penggunaan Voucher', active: true },
      ],
    },
  },
]
